import { LabelValueSet } from "../utility/LabelValueSet";

const SensorType = Symbol();

export class Sensor extends LabelValueSet  {
    [SensorType]: any;
}

const エアコン = new Sensor("エアコン", "エアコン");
const テレビ = new Sensor("テレビ", "テレビ");
const 洗濯機 = new Sensor("洗濯機", "洗濯機");
const レンジ = new Sensor("レンジ", "レンジ");
const 炊飯器 = new Sensor("炊飯器", "炊飯器");
const 掃除機 = new Sensor("掃除機", "掃除機");
const IH = new Sensor("IH", "IH");
const 暖房機器 = new Sensor("暖房機器", "暖房機器");
const 居間_温湿度計 = new Sensor("居間", "居間_温湿度計");
const 浴室 = new Sensor("浴室", "浴室");
const 居間_人感センサー = new Sensor("居間", "居間_人感センサー");
const トイレ = new Sensor("トイレ", "トイレ");

const mapValueToItem: { [key: string] : Sensor} = {
    "エアコン": エアコン,
    "テレビ": テレビ,
    "洗濯機": 洗濯機,
    "レンジ": レンジ,
    "炊飯器": 炊飯器,
    "掃除機": 掃除機,
    "IH": IH,
    "暖房機器": 暖房機器,
    "居間_温湿度計": 居間_温湿度計,
    "浴室": 浴室,
    "居間_人感センサー": 居間_人感センサー,
    "トイレ": トイレ,
};

// 登録画面初期値
export const initialCheckedList: string[] = [
    "エアコン",
    "テレビ",
    "洗濯機",
    "レンジ",
    "炊飯器",
    "掃除機",
    "IH",
    "暖房機器",
    "居間_温湿度計",
    "浴室",
    "居間_人感センサー",
    "トイレ",
];

// 家電
export const homeApplianceList: readonly Sensor[] = [
    エアコン,
    テレビ,
    洗濯機,
    レンジ,
    炊飯器,
    掃除機,
    IH,
    暖房機器,
];

// 温湿度計
export const thermoHygrometerList: readonly Sensor[] = [
    居間_温湿度計,
    浴室,
];

// 人感センサー
export const motionSensorList: readonly Sensor[] = [
    居間_人感センサー,
    トイレ,
];

export const getSensorFromValue = (value: string): Sensor | undefined => {
    return mapValueToItem[value];
};

export type SensorJson = {
    sensor: string
};
